// libraries
import type { StateTree } from '@makemydeal/dr-dash-types';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';

// consts/enums
import { SavedOfferPayloadObjectComparison } from '../types/comparisonUtilsEnums';

// selectors

// utils
import { compareOfferPayloadObjects } from '../utils/comparisonUtils';
import { buildComparablePayload, getLastOfferPayloadObject, withoutGridDataHiddenSince } from '../utils/unsavedChangesUtils';

export const currentOfferHasUnsavedChanges = (state: StateTree) => {
    const offerSavePayload = buildComparablePayload(state);
    const lastOfferPayloadObject = featureToggleSelectors.isUseGridHideComparisonEnabled(state)
        ? withoutGridDataHiddenSince(getLastOfferPayloadObject(), offerSavePayload)
        : getLastOfferPayloadObject();
    const comparisonResult = compareOfferPayloadObjects(lastOfferPayloadObject, offerSavePayload);
    return comparisonResult.simpleResult === SavedOfferPayloadObjectComparison.Different;
};
